import { render, staticRenderFns } from "./tabBoss.vue?vue&type=template&id=2a226964&scoped=true&"
import script from "./tabBoss.vue?vue&type=script&lang=js&"
export * from "./tabBoss.vue?vue&type=script&lang=js&"
import style0 from "./tabBoss.vue?vue&type=style&index=0&id=2a226964&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a226964",
  null
  
)

export default component.exports